export enum UserRole {
    Admin = 'ADMIN',
    User = 'USER',
    None = 'NONE', // Used for anonymous user
}